import { render, staticRenderFns } from "./LabelReports.vue?vue&type=template&id=030ab1c5"
import script from "./LabelReports.vue?vue&type=script&lang=js"
export * from "./LabelReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports